<template>
  <div class="clue-detail">
    <van-nav-bar fixed title="证明文书" left-arrow @click-left="$router.go(-1)"></van-nav-bar>
    <div id="printbox" ref="content">
      <div class="title">项目推荐证明</div>
      <div
        class="content"
      >兹证明，项目推荐人{{data.businessUser}}(身份证号：{{data.businessIdCard}})，推荐的“{{data.projectName}}”项目，于{{time}}被重庆市九龙坡区招商投资促进局认定有效。</div>
      <div id="qrcode" ref="qrcode"></div>
      <div class="content2">
        <div>重庆市九龙坡区招商投资促进局</div>
        <div>{{time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      data: {},
      time: "",
      infodata: {}
    };
  },
  methods: {
    toPdf() {
      this.$PDFSave(this.$refs["content"], "我的文件");
    },
    qrcode() {
      this.$refs.qrcode.innerHTML = ""; // 清空之前生成的二维码内容
      let qrcode = new QRCode("qrcode", {
        width: 100, // 设置宽度，单位像素
        height: 100, // 设置高度，单位像素
        text: this.infodata.moneyCode // 设置二维码内容或跳转地址(完整链接)
      });
    },
    getdetaildata(id) {
      this.request({
        url: "v1.0/Project/getDetailTitle",
        method: "GET",
        params: {
          projectId: id
        }
      }).then(res => {
        this.data = res.data;
        var timestr = this.data.getMoneyTime.substr(0, 10).replace(/-/g, "/");
        var timestamp = new Date(timestr).getTime();
        this.time = this.timestampToTime(timestamp);
      });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "年";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "月";
      let D = date.getDate() + "日";
      let h = date.getHours() + ":";
      let m = date.getMinutes() + ":";
      let s = date.getSeconds();
      console.log(Y + M + D, 888);
      return Y + M + D; //时分秒可以根据自己的需求加上
    }
  },
  computed: {},
  created() {
    console.log(this.$route.query.data, 888);
    this.getdetaildata(this.$route.query.data);
    this.infodata = JSON.parse(window.sessionStorage.getItem("order"));
    this.$nextTick(() => {
      this.qrcode();
    });
  }
};
</script>

<style lang="scss" scoped>
.clue-detail {
  padding-top: 8vh;
  background: #ffffff;
  min-height: 100vh;
  position: relative;
}
#printbox {
  position: relative;
  text-align: center;
}
.title {
  margin-top: 10px;
  font-weight: bold;
  font-family: fzxbs;
  font-size: 18px;
}
.content {
  font-family: fzxbs;
  font-size: 16px;
  width: 87%;
  text-indent: 30px;
  text-align: left;
  margin: 30px auto;
}
#qrcode {
  margin: 0 auto;
  text-align: center;
  width: 100%;
  /deep/ img {
    margin: 15% auto;
  }
}
.content2 {
  font-family: fzxbs;
  font-size: 16px;
  position: absolute;
  bottom: -34%;
  left: 30%;
}
</style>
